import { useTranslations } from '@altermaind/core/i18n';
import { Asset, Box, IconButton, Typography } from '@altermaind/web/ui';
import aiPlayGround from '@/_shared/assets/documents/AI_Playground_brochure_Slash_HR_v01.pdf';
import { downloadFile } from '@/_shared/helpers/download';
import { useResponsiveStyle } from '@/_shared/hooks/useResponsiveStyle';

export const IntroPlayground = () => {
  const t = useTranslations('aiPlayground.admin.landingPlayground');
  const { genericResponsiveValue } = useResponsiveStyle();

  return (
    <Box
      alignItems='center'
      display='flex'
      flexDirection={genericResponsiveValue({
        breakPoints: { desktop: 'row' },
        defaultValue: 'column',
      })}
      mb='xl'
    >
      <Box flex='1'>
        <Typography mb='xs' variant='h1'>
          {t('title')}
        </Typography>
        <Typography variant='p2/light'>{t('description')}</Typography>
        <IconButton
          color='primary/interactive'
          variant='positive'
          mt='s'
          prefixSvg='download'
          svgStyle={{ fill: 'primary', size: 'xs' }}
          textStyle={{ ml: 'xxxs' }}
          onClick={() => downloadFile(aiPlayGround, 'AI Playground Slash')}
        >
          {t('buttonText')}
        </IconButton>
      </Box>
      <Box
        textAlign='right'
        flex='1'
        mt={genericResponsiveValue({
          breakPoints: { desktop: 'none' },
          defaultValue: 'l',
        })}
      >
        <Asset maxWidth='400px' domain='images' name='introPlayground' />
      </Box>
    </Box>
  );
};
